import * as models from '../../domain/models';
import * as actions from '../actions/user-activities-collection';
import * as viewModels from '../../view/view-models';

import * as _ from 'lodash';

export interface State {
  isLoaded: boolean;
  isLoading: boolean;
  items: Array<models.UserActivity>;
  lookup: viewModels.UsersActivitiesLookup;
}

const initialState: State = {
  isLoaded: false,
  isLoading: false,
  items: [],
  lookup: new viewModels.UsersActivitiesLookup(),
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.LOAD_USER_ACTIVITIES: {
      return {
        ...state,
        lookup: _.cloneDeep(action.payload.lookup),
        isLoading: true,
      };
    }

    case actions.LOAD_USER_ACTIVITIES_SUCCESS: {
      const items = _.cloneDeep(action.payload.activities);
      const lookup = _.cloneDeep(state.lookup);
      lookup.total = action.payload.totalItems;
      return {
        ...state,
        isLoaded: true,
        isLoading: false,
        lookup,
        items,
      };
    }

    case actions.LOAD_USER_ACTIVITIES_FAILURE: {
      const lookup = _.cloneDeep(state.lookup);
      return {
        ...initialState,
        isLoaded: true,
        lookup,
      };
    }

    case actions.RESET: {
      return {
        ...initialState,
      }
    }

    default: {
      return state;
    }
  }
}

export const getIsLoaded = (state: State) => state.isLoaded;
export const getIsLoading = (state: State) => state.isLoading;
export const getItems = (state: State) => state.items;
export const getLookup = (state: State) => state.lookup;
